export default __webpack_public_path__ + "static/media/envelope.15661445.svg";